/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tpm_Field_Notes_PlaceholderInputs */

const en_tpm_field_notes_placeholder = /** @type {(inputs: Tpm_Field_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what happened so the service desk can follow up.`)
};

const ja_tpm_field_notes_placeholder = /** @type {(inputs: Tpm_Field_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクが対応できるよう、何が起きたか記入してください。`)
};

const fr_tpm_field_notes_placeholder = /** @type {(inputs: Tpm_Field_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce qui s'est passé pour que le service desk puisse assurer le suivi.`)
};

const de_tpm_field_notes_placeholder = /** @type {(inputs: Tpm_Field_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreiben Sie, was passiert ist, damit der Service Desk nachfassen kann.`)
};

/**
* | output |
* | --- |
* | "Describe what happened so the service desk can follow up." |
*
* @param {Tpm_Field_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const tpm_field_notes_placeholder = /** @type {((inputs?: Tpm_Field_Notes_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tpm_Field_Notes_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tpm_field_notes_placeholder(inputs)
	if (locale === "ja") return ja_tpm_field_notes_placeholder(inputs)
	if (locale === "fr") return fr_tpm_field_notes_placeholder(inputs)
	return de_tpm_field_notes_placeholder(inputs)
});